import fornecedorService from "../../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */

export default {
    data() {//Declaracao de variaveis

      return {
      }
    },
    methods: {//Declaracao de todos os metodos
        editarItem(itemLista) {
        this.$emit("editarItem", itemLista);
        },

        aprovarHabilitacao(itemLista) {
            let model = Object.assign({}, itemLista);
            model.habilitacaoJuridicaSituacao = 2;
            model.idMotivoIndeferimentoArquivo = null;
            fornecedorService.aprovarRejeitarHabilitacao(model).then(response => { /*resposta do servico*/
              this.model.fornecedoresHabilitacaoJuridica = response.data; /*dados de retorno*/
              this.habilitacaoLista.sociosLista = [];
              this.habilitacaoLista.dirigentesLista = [];

              this.model.fornecedoresHabilitacaoJuridica.filter(item => {
                if (item.tipoCadastro === "D") {
                  this.habilitacaoLista.dirigentesLista.push(item);
                } else {
                  this.habilitacaoLista.sociosLista.push(item);
                }
              });
              if (!this.habilitacaoLista.sociosLista.length) {
                this.erroHabilitacaoJuridica.erro = false;
              }
              this.$toasted.success(this.$t("messages.cadastro.aprovadoComSucesso"));
            });
        },

        rejeitarHabilitacao(motivoSelecionado) {
            const selecao = motivoSelecionado && typeof motivoSelecionado === 'object'
              ? motivoSelecionado
              : { motivoSelecionado: motivoSelecionado, motivoSelecionado2: null, motivoSelecionado3: null };
            var tipo = null;
            let model = Object.assign({}, this.itemRejeitado);
            model.habilitacaoJuridicaSituacao = 1;
            model.idMotivoIndeferimentoArquivo = selecao.motivoSelecionado;
            model.idMotivoIndeferimentoArquivo2 = selecao.motivoSelecionado2;
            model.idMotivoIndeferimentoArquivo3 = selecao.motivoSelecionado3;
            fornecedorService.aprovarRejeitarHabilitacao(model).then(response => { /*resposta do servico*/
                this.model.fornecedoresHabilitacaoJuridica = response.data; /*dados de retorno*/
                this.habilitacaoLista.sociosLista = [];
                this.habilitacaoLista.dirigentesLista = [];

                this.model.fornecedoresHabilitacaoJuridica.filter(item => {
                if (item.tipoCadastro === "D") {
                    this.habilitacaoLista.dirigentesLista.push(item);
                } else {
                    this.habilitacaoLista.sociosLista.push(item);
                }
                tipo = item.tipoCadastro;
                });
                if (!this.habilitacaoLista.sociosLista.length) {
                this.erroHabilitacaoJuridica.erro = false;
                }
                if (tipo === "D") {
                    this.modelDialogRejeitarDirigente.open = false;
                } else {
                    this.modelDialogRejeitarSocio.open = false;
                    this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
                }
            });
        },
    }
  }
